import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ChatHttpService, ChatRoom } from '../../services/chat-http.service';
import { ChatService } from '../../services/chat.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzModalCreateChatComponent } from './modals/create-chat/create-chat.component';
import { NzModalDeleteChatComponent } from './modals/delete-chat/delete-chat.component';
import { takeUntil } from "rxjs/operators";
import { JitsyService } from '../../global-components/jitsi/jisti.service';
import { NzModalHungUp } from '../../global-components/modals/modal-hungup/modal-hung-up.component';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit, OnDestroy {
  @ViewChild('bodyChat') chatContent: ElementRef;
  chatAll$: BehaviorSubject<ChatRoom[]>;
  chatCurrent$: BehaviorSubject<ChatRoom>;
  callActive$: BehaviorSubject<boolean>;
  destroy$ = new Subject();
  isCall = false;
  roomCode: string;
  isLoaded:boolean;
  constructor(private chatHttp: ChatHttpService,
              public authService: AuthService,
              private chatService: ChatService,
              private modal: NzModalService,
              private viewContainerRef: ViewContainerRef,
              private jitsyService: JitsyService) { }

  ngOnInit(): void {

    this.jitsyService.closeCall$.pipe(takeUntil(this.destroy$)).subscribe(call => {
      if (call) {
        this.chatService.callEnd();
        this.jitsyService.closeCall$.next(false);
      }
    });

    this.jitsyService.update$.pipe(takeUntil(this.destroy$)).subscribe(update => {
      this.chatService.initChats();
    });

    this.jitsyService.hungUp$.pipe(takeUntil(this.destroy$)).subscribe(call => {
      if (call) {
        this.chatService.callEnd();
        if (call.SenderType !== 'convicted') {
          const modal: NzModalRef = this.modal.create({
            nzContent: NzModalHungUp,
            nzViewContainerRef: this.viewContainerRef,
            nzOnOk: () => new Promise(resolve => console.log(resolve)),
          });
        }
        this.jitsyService.hungUp$.next(false);
      }
    });


    this.chatService.chatLoaded$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.isLoaded = x;
    });
    this.chatService.initChats();
    this.chatCurrent$ = this.chatService.chatCurrent$;
    this.chatAll$ = this.chatService.chatAll$;
    this.callActive$ = this.chatService.callActive$;
    this.chatCurrent$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      if (!x) {
        return;
      }
      setTimeout(() => {
        console.log(this.chatContent);
        this.chatContent.nativeElement.scrollTop = this.chatContent.nativeElement.scrollHeight;
      });

    });

    this.callActive$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.chatService.initChats();
    })
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.chatService.callEnd();
  }

  currentChat(room: ChatRoom) {
    this.chatService.chatActive(room);
  }

  addChat() {
    const modal: NzModalRef = this.modal.create({
    nzContent: NzModalCreateChatComponent,
      nzViewContainerRef: this.viewContainerRef,
      // nzViewContainerRef: this.viewContainerRef,
      nzComponentParams: {
        cancelTextBtn: 'Отмена',
        confirmTextBtn: 'Добавить',
      },
      nzOnOk: () => new Promise(resolve => console.log(resolve)),
    });

    /*modal.afterClose.pipe(take(1)).subscribe(x => {
      if (x?.data) {
      }
    })*/
  }


  deleteChat() {
    console.log('delete');
    const modal: NzModalRef = this.modal.create({
      nzContent: NzModalDeleteChatComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzComponentParams: {
        cancelTextBtn: 'Отмена',
        confirmTextBtn: 'Да, удалить',
        user: this.chatCurrent$.getValue().User.UserFirstName + ' ' + this.chatCurrent$.getValue().User.UserLastName,
        chatID: this.chatCurrent$.getValue().ChatID,
      },
      nzOnOk: () => new Promise(resolve => console.log(resolve)),
    });

    /*modal.afterClose.pipe(take(1)).subscribe(x => {
      if (x?.data) {
      }
    })*/
  }

  callActive() {
    // @ts-ignore
    this.roomCode = window.crypto.randomUUID();
    console.log(this.roomCode);
    const currentChat = this.chatCurrent$.getValue();
    const data = { ChatID: currentChat.ChatID, UserID: currentChat.User.UserID, RoomCode: this.roomCode };
    this.chatService.callStart(data);
  }

  inviteCurrentChat(phone: string) {
    this.chatHttp.inviteChat({UserPhone: phone}).subscribe(x => {
      this.chatService.chatUpdate();
    }, error => {
      console.error(error);
      // this.serverError = error.error.detail;
    })
  }

  back() {
    // @ts-ignore
    this.chatService.chatCurrent$.next(null);
  }
}

